import React from 'react';
import { Phone, MapPin, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Teja's Pet Care</h3>
          <p className="telugu-text">తేజ'ఎస్ పేట కేర్</p>
          <p>24/7 Compassionate Veterinary Care You Can Trust</p>
          <div className="rating-container" style={{ marginTop: '1rem' }}>
            <span style={{ fontSize: '1.2rem' }}>⭐ 4.8</span>
            <span>(269 Google Reviews)</span>
          </div>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/services">Services</Link>
          <Link to="/reviews">Reviews</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-section">
          <h3>Contact Info</h3>
          <p style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
            <Phone size={18} style={{ flexShrink: 0, marginTop: '2px' }} />
            <span>+91 81999 81444</span>
          </p>
          <p style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
            <MapPin size={18} style={{ flexShrink: 0, marginTop: '2px' }} />
            <span>Cosmo Club Road, near Varma's Kitchen, Bhimavaram, Andhra Pradesh 534202</span>
          </p>
          <p style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
            <Clock size={18} style={{ flexShrink: 0, marginTop: '2px' }} />
            <span>Open 24 Hours - Emergency Services Available</span>
          </p>
        </div>

        <div className="footer-section">
          <h3>Our Services</h3>
          <p>Pet Consultation & Diagnosis</p>
          <p>Emergency & Critical Care</p>
          <p>Parvovirus Treatment</p>
          <p>Grooming & Boarding</p>
          <p>Home Services</p>
          <p>Street Animal Care</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Teja's Pet Care. All rights reserved. | Best Veterinary Hospital in Bhimavaram</p>
      </div>
    </footer>
  );
};

export default Footer;